/* eslint-disable camelcase */
export default {
	gokr_validation_goalName: "Goal name is required",
	gokr_validation_dates: "Goal start date must be before the end (target) date.",
	gokr_validation_krName: "Name is required",
	gokr_validation_krOwner: "Owner is required",
	gokr_validation_krPercentageGoalExceedMax: "Target value must be less than 100%",
	gokr_validation_krPercentageGoalExceedMin: "Target value must be greater than 0%",
	gokr_validation_krPercentageGoalInvalidVal: "Target value must be a valid percentage",
	gokr_validation_krCurrencyGoalInvalid: "Target value must be numeric currency.",
	gokr_validation_krCurrencyGoalLessThan0: "Target value must be a positive number.",
	gokr_validation_krNumericGoalInvalid: "Target value must be a valid real number",
	gokr_validation_krNumericGoalLessThan0: "Target value must be a positive number.",
	gokr_validation_krPercentageCurrentExceedMax: "Current value must be less than 100%",
	gokr_validation_krPercentageCurrentExceedMin: "Current value must be greater than 0%",
	gokr_validation_krPercentageCurrentInvalidVal: "Current value must be a valid percentage",
	gokr_validation_krCurrencyCurrentInvalid: "Current value must be numeric currency.",
	gokr_validation_krCurrencyCurrentLessThan0: "Current value must be a positive number.",
	gokr_validation_krNumericCurrentInvalid: "Target value must be a valid real number",
	gokr_validation_krNumericCurrentLessThan0: "Target value must be a positive number.",

	team_validation_teamName: "Team name is required.",
	team_validation_memberBeingAdded: "Please enter a valid email address.",
	team_validation_duplicateMemberBeingAdded: "This email belongs to an existing team member.",
};
/* eslint-enable camelcase */
